import {Pipe, PipeTransform, Injectable, Inject} from '@angular/core';
import { AttachmentTypeModel } from '@app/common/models/attachment-type.model';
import { APP_BRAND } from '@app/common/services/config.service';

export type AttachmentTypePipeField = 'icon' | 'title';

@Pipe({ name: 'attachmentType' })
@Injectable({
  providedIn: 'root'
})
export class AttachmentTypePipe implements PipeTransform {

  constructor(
    @Inject(APP_BRAND) private APP_BRAND: any,
  ) {}

  transform(attachment: any, field: AttachmentTypePipeField = 'title'): string {
    const attachmentType = AttachmentTypeModel.createById(attachment.type || attachment.id);

    switch (field) {
      case 'title':
        return this.APP_BRAND.NAME === 'RSD' ? attachmentType.titleMpv : attachmentType.title;
      case 'icon':
        return attachmentType.icon;
    }
  }
}
